import { useMemo } from 'preact/hooks';
import { useLookups } from '@/hooks/useLookups';
export function useTimeZones() {
    const { getTimeZones } = useLookups();
    // Memoize the timeZones call to prevent triggering fetchIndividualLookup on every render
    const timeZones = useMemo(() => getTimeZones() || [], [getTimeZones]);
    // Helper to get timezone abbreviation by IANA ID
    const getAbbreviation = useMemo(() => {
        return (ianaId) => {
            if (!ianaId || !timeZones)
                return '';
            const tz = timeZones.find(t => t.Id === ianaId);
            return tz?.Abbreviation || '';
        };
    }, [timeZones]);
    // Helper to get full timezone display name by IANA ID
    const getDisplayName = useMemo(() => {
        return (ianaId) => {
            if (!ianaId || !timeZones)
                return '';
            const tz = timeZones.find(t => t.Id === ianaId);
            if (!tz?.DisplayName)
                return '';
            // Strip out UTC offset portion: "(UTC-05:00) Eastern Time" -> "Eastern Time"
            const displayName = tz.DisplayName.replace(/^\(UTC[^)]*\)\s*/, '');
            return displayName;
        };
    }, [timeZones]);
    return {
        timeZones,
        getAbbreviation,
        getDisplayName,
    };
}
